




const EMAIL_RE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const isValidEmail = (email: string) => EMAIL_RE.test(email.trim());

export default isValidEmail;